import React from 'react';
import {
  Box,
  Container,
  AppBar,
  Toolbar,
} from '@mui/material';
import { useAppContext } from '../context/AppContext';
import LandingPage from '../components/LandingPage';
import OTPInputCard from '../components/OtpVerification';
import { BRANDING } from '../appConfig';

const AuthPage = () => {
  const { state, actions } = useAppContext();

  const handleProceed = (action, userData) => {
    if (action === 'proceed') {
      // Send OTP and update state with user data
      actions.sendOTP(userData);
    }
  };

  const handleOTPVerify = (response) => {
    // OTP verification successful
    actions.verifyOTP();
  };

  const handleOTPResend = () => {
    return state.phoneNumber;
  };

  const handleBackToLanding = () => {
    // Reset OTP state and go back to landing
    actions.setAuthState({ 
      otpSent: false,
      // Keep user data for convenience
      // clientName: '',
      // email: '',
      // phoneNumber: ''
    });
  };

  return (
    <Box sx={{ flexGrow: 1, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* AppBar */}
      <AppBar position="static" sx={{ backgroundColor: '#000000' }}>
        <Toolbar>
          <a href={BRANDING.websiteUrl} target='_blank' rel="noopener noreferrer">
            <img 
              src={BRANDING.logoPath}
              alt={BRANDING.logoAlt}
              style={{ height: 20, marginRight: 30 }} 
            />
          </a>
          {/* <Typography 
            variant="h6" 
            component="div" 
            sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
          >
            Plan Your Goals
          </Typography> */}
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container sx={{
        // flexGrow: 1,
        py: 2,
        // display: 'flex',
        // flexDirection: 'column',
        // gap: 2,
        // overflow: 'auto',
        width: { sm: '100%', md: '30%' },
        // alignItems: 'center',
        // justifyContent: 'center'
      }}>
        {!state.otpSent ? (
          <LandingPage
            onChange={handleProceed}
          />
        ) : (
          <OTPInputCard
            phoneNumber={state.phoneNumber}
            onVerify={handleOTPVerify}
            onResend={handleOTPResend}
            onBack={handleBackToLanding}
          />
        )}
      </Container>
    </Box>
  );
};

export default AuthPage;
